import React, { useState } from 'react'
import classNames from 'classnames';

import ElementModal from './ElementModal'
import { Row, Column } from 'components/Layout';

import style from './_modal.module.scss';


const ConfigurationDescriptor = ({ configuration: item, selected, setSelected }) => {
    let cn = classNames(style.configurationBrief, (item.id === selected) && style.configurationBriefSelected)

    return <div className={cn} onClick={() => setSelected(item.id)}>
        <div>{item?.code}</div>
        <div>{item?.description}</div>
    </div>
}

const SlotDescriptor = ({ sensor }) => {
    return sensor ?
        <div className={style.sensorInfo}>
            <div>Id Sensore</div>
            <div>{sensor?.id}</div>
            <div>Nome</div>
            <div>{sensor?.name}</div>
            <div>Modello</div>
            <div>{sensor?.model}</div>
        </div>
        :
        <div>Vuoto</div>
}


const AssignConfigurationModal = ({ isOpen, onClose, onSubmit, device, assignedConfigId, setAssignedConfigId, allConfigs }) => {
    const [configSearch, setConfigSearch] = useState('')

    let cur = allConfigs.find(c => c.id === assignedConfigId)
    let filteredConfigs = allConfigs
        .filter(c => c?.code.includes(configSearch) || c?.description?.toLowerCase().includes(configSearch.toLowerCase()))
        .sort((a, b) => a.code.localeCompare(b.code))

    return (
        <ElementModal isOpen={isOpen} onClose={onClose} submit={onSubmit} className={classNames(style.modal, style.assignConfigurationModal)}>
            <Column className={classNames(style.section, style.configurationSection)}>
                <Row className={style.title}>Tutte le configurazioni</Row>
                <Row className={style.fields}>
                    Cerca
                    <input className={style.searchbar}
                        type={"text"}
                        placeholder={"Codice / Descrizione"}
                        value={configSearch}
                        onChange={e => setConfigSearch(e.target.value)}
                    />
                </Row>
                <Row className={style.configurationBrief} style={{ border: "0" }}>
                    <div>Codice</div>
                    <div>Descrizione</div>
                </Row>
                {
                    filteredConfigs.map(c =>
                        <ConfigurationDescriptor
                            key={c.id}
                            configuration={c}
                            selected={assignedConfigId}
                            setSelected={setAssignedConfigId}
                        />
                    )
                }
            </Column>
            <Column className={style.section}>
                <Row className={style.title}>{`Configurazione centralina ${device}`}</Row>
                {
                    cur ?
                        <div className={style.configurationInfo}>
                            <div>Codice</div>
                            <div>{cur?.code ?? '-'}</div>
                            <div>Descrizione</div>
                            <div>{cur?.description ?? '-'}</div>
                            <div>Slot 1</div>
                            <SlotDescriptor sensor={cur.slot1} />
                            <div>Slot 2</div>
                            <SlotDescriptor sensor={cur.slot2} />
                            <div>Slot 3</div>
                            <SlotDescriptor sensor={cur.slot3} />
                            <div>Slot 4</div>
                            <SlotDescriptor sensor={cur.slot4} />
                            <div>Slot 5</div>
                            <SlotDescriptor sensor={cur.slot5} />
                            <div>Slot 6</div>
                            <SlotDescriptor sensor={cur.slot6} />
                            <div>Slot 7</div>
                            <SlotDescriptor sensor={cur.slot7} />
                            <div>Slot 8</div>
                            <SlotDescriptor sensor={cur.slot8} />
                        </div>
                        :
                        <p>Nessuna configurazione assegnata</p>
                }
            </Column>
        </ElementModal>
    )
}

export default AssignConfigurationModal